import './style.css'

import React from 'react'
import _ from 'lodash'

const getColourClass = (availability: string) => {
  switch (availability) {
    case 'Available now':
      return 'vehicle_available'
    case 'Confirmed future model':
      return 'confirmed_future_model'
    case 'Potential future model':
      return 'potential_future_model'
    case 'Available with exemptions':
      return 'available_with_exemptions'
    case 'Discontinued':
      return 'discontinued'
    default:
      return 'vehicle_available'
  }
}

const ResponsiveTable = ({ data }: any) => {
  return (
    <div className="grid_wrapper">
      {data.map((obj: any) => {
        const gvmTBC =
          obj['gvm'] !== 'TBC'
            ? `${_.isNil(obj['gvm_start_value']) ? '' : obj['gvm_start_value']}  
            ${obj['gvm']}
            ${_.isNil(obj['gvm_end_value']) ? '' : obj['gvm_end_value']}  kg`
            : obj['gvm']
        const payloadTbc = obj['payload'] !== 'TBC' ? `${obj['payload']} kg` : obj['payload']
        const capacityTbc =
          obj['capacity'] !== 'TBC' && obj['type'] !== 'Fuel cell'
            ? `${_.isNil(obj['capacity_start_value']) ? '' : obj['capacity_start_value']} 
            ${obj['capacity']} kWh`
            : obj['capacity']
        const rangeTbc = obj['range'] !== 'TBC' ? `${obj['range']} km` : obj['range']

        const vehicle_type = obj['type'] === 'Electric' ? 'electric_type' : 'fuel_cell'
        const vehicle_type_classNames = `vehicle_type_container ${vehicle_type}`

        const vehicle_availability_colour = getColourClass(obj['availability'])
        const vehicle_availability_classNames = `vehicle_availability_classNames ${vehicle_availability_colour}`

        return (
          <div className="grid_card">
            <div className="card_header">
              <div className="header_group">
                <h1>{obj['make_model']}</h1>
                <div className={vehicle_type_classNames}>{obj['type']}</div>
              </div>
              <div className={vehicle_availability_classNames}>{obj['availability']}</div>
            </div>
            <div className="card_body">
              <div className="card_body_column">
                <h1>GVM</h1>
                <p>{gvmTBC}</p>
              </div>
              <div className="card_body_column">
                <h1>Payload</h1>
                <p>{payloadTbc}</p>
              </div>
              <div className="card_body_column">
                <h1>Battery / hydrogen capacity</h1>
                <p>{capacityTbc}</p>
              </div>
              <div className="card_body_column">
                <h1>Range up to</h1>
                <p>{rangeTbc}</p>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default ResponsiveTable
